export interface BootstrapOptions {
    extensionTimeout?: number;
    shutdown?: boolean;
}
